import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ApiError } from '../api/api-error';
import { PaymentsApi } from '../api/payments.api';
import type { PaymentProvider } from '../models/order/order.model';
import type { ApiEnvelope } from './api-envelope';
import { apiPath, mapApiError, unwrapEnvelope } from './api-envelope';

const CHECKOUT_LINK_PATH = '/api/payments/checkout-link';
const PROVIDERS_PATH = '/api/users/client/payment-providers';

/** Порядок кнопок задаёт сайт, а не ответ: так он не прыгает между заходами. */
const KNOWN_PROVIDERS: readonly PaymentProvider[] = ['CLICK', 'PAYME'];

@Injectable()
export class PaymentsHttpApi extends PaymentsApi {
  private readonly http = inject(HttpClient);

  override providers(): Observable<readonly PaymentProvider[]> {
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath(PROVIDERS_PATH))
      .pipe(unwrapEnvelope<unknown>(), map(readProviders), mapApiError());
  }

  override checkoutLink(
    orderId: string,
    provider: PaymentProvider,
    returnUrl: string,
  ): Observable<string> {
    const params = new HttpParams()
      .set('orderId', orderId)
      .set('provider', provider)
      .set('returnUrl', returnUrl);
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath(CHECKOUT_LINK_PATH), { params })
      .pipe(unwrapEnvelope<unknown>(), map(readLink), mapApiError());
  }
}

/** Uzum и будущие провайдеры отсеиваются: кнопки и знака для них у сайта нет. */
function readProviders(raw: unknown): readonly PaymentProvider[] {
  return Array.isArray(raw)
    ? KNOWN_PROVIDERS.filter((provider) => (raw as unknown[]).includes(provider))
    : [];
}

/** Граница доверия: строка уедет в location — ничего, кроме https-URL, не пропускаем. */
function readLink(raw: unknown): string {
  if (typeof raw !== 'string' || !raw.startsWith('https://')) {
    throw new ApiError(500, 'unknown');
  }
  return raw;
}
